import $ from 'jquery'

$(document).on('click', 'a[data-behaviour~="star-link"]', function () {
  return $(this)
    .closest('[data-behaviour="account-list-item"]')
    .toggleClass('starred unstarred')
})
